import { render, staticRenderFns } from "./FormInhabilitarSillon.vue?vue&type=template&id=d8e6056a"
import script from "./FormInhabilitarSillon.vue?vue&type=script&lang=js"
export * from "./FormInhabilitarSillon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports